import React, { useEffect } from "react";
import { CircularProgress } from "@mui/material";

import { useHistory } from "hooks/useHistory";
import { useAuthenticationStatus } from 'hooks/useAuthenticationStatus';

import orgsOwnedPortalListPage from "../orgs-portal-list";
// import newPortalFormPage from "../new-portal-form";
import signInPage from "../sign-in";

import styles from "./Home.module.scss";

export default function Home(props: {}): JSX.Element {
  const history = useHistory();
  const { isAuthenticated } = useAuthenticationStatus();

  useEffect(
    () => {
      if (isAuthenticated) {
        history.replace(orgsOwnedPortalListPage.getHref());
      } else {
        // history.replace(newPortalFormPage.getHref());
        history.replace(signInPage.getHref());
      }
    },
    [ isAuthenticated ]
  );

  return (
    <div className={styles.spinnerContainer}>
      <CircularProgress className={styles.spinner}/>
    </div>
  );
}
